import { Alert, AlertTitle } from '@material-ui/lab'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { CostDetail } from '../components/CostDetail'
import { OrderContext, OrderSimulationData } from '../OrderContext'
import { getDate } from '../util'
import PurchaseDisplay from './PurchaseDisplay'
import ReturnDisplay from './ReturnDisplay'

type SummaryProps = { disableSmall?: boolean, simulateOverride?: OrderSimulationData }

const Summary: React.FC<SummaryProps> = ({ disableSmall, simulateOverride }) => {
    const { loadingSimulate, simulate, errorOnSimulate, orderType, customer: { language }, purchases } = useContext(OrderContext)
    const { t } = useTranslation()

    const s = simulateOverride || simulate

    if (loadingSimulate && !simulateOverride) return <p>{t('loading_order_summary')}...</p>
    if (errorOnSimulate && !simulateOverride) return <p>{t('generic_error')}...</p>

    return (
        <>
            {(!loadingSimulate || simulateOverride) && <>
                <ReturnDisplay simulateOverride={simulateOverride} disableSmall={disableSmall} type='returns' title={t('return_items')} />
                <ReturnDisplay simulateOverride={simulateOverride} disableSmall={disableSmall} type='exchanges' title={t('return_items')} />
                {orderType === 'Exchange' && <PurchaseDisplay disableSmall={disableSmall} simulateOverride={simulateOverride} />}
            </>}

            {(!loadingSimulate || simulateOverride) && orderType !== 'Return' && <CostDetail label={t('grand_total', { currency: s?.currency })} subLabel={t('total_minus_returns')} amount={s?.grandTotal || 0} />}

            {(!loadingSimulate || simulateOverride) && s?.temporaryOutOfStock.length !== 0 &&
                <Alert severity="error" style={{ marginTop: 60, marginBottom: 30 }}>
                    <AlertTitle>{t('arrive_late')}</AlertTitle>
                    <ul>
                        {s?.temporaryOutOfStock.map((item, i) =>
                            <li key={i}>
                                {t('stock', {
                                    available: item.confirmQuantity,
                                    requested: item.quantity,
                                    product_name: purchases.find(p => p.productId === item.material)?.productName,
                                    material: item.material,
                                    estimated_delivery: getDate(item.estimatedDeliveryDate, language)
                                })}
                            </li>)}
                    </ul>
                </Alert>
            }
        </>
    )
}

export default Summary
